export function loadChatbot() {
    if (window.flowiseLoaded) return;
    window.flowiseLoaded = true;
    const chatflowid = process.env.VUE_APP_PROD_FLOWISE_CHAT_FLOW_ID;
  
    const script = document.createElement("script");
    script.id = "flowise-script";
    script.type = "module";
  
    script.innerHTML = `
      import Chatbot from "https://cdn.jsdelivr.net/npm/flowise-embed/dist/web.js";
  
      Chatbot.init({
        chatflowid: "${chatflowid}",
        apiHost: "https://cloud.flowiseai.com",
        theme: {
          button: {
            backgroundColor: '#435851',
            dragAndDrop: true,
            iconColor: 'white',
          },
          chatWindow: {
            userMessage: {
              backgroundColor: '#435851',
              textColor: '#ffffff',
            },
            textInput: {
              sendButtonColor: '#435851',
            },
            footer: {
              textColor: '#303235',
              text: 'Powered by',
              company: 'Expertizo',
              companyLink: 'https://www.expertizo.pk',
            },
          },
        }
      });
    `;
  
    document.body.appendChild(script);
  }
  
  export function unloadChatbot() {
    window.flowiseLoaded = false;
  
    const script = document.getElementById("flowise-script");
    if (script) script.remove();
  
    document
      .querySelectorAll("flowise-chatbot, .flowise-chatbot-container, .flowise-chatbot-button")
      .forEach((el) => el.remove());
  }
  


// WEBPACK FOOTER //
// ./src/utils/chatbotLoader.js